module.exports = __webpack_public_path__ + "img/badge-highest-lead-quality-keyvue-green.c1108e88.png";